import { useEffect, useMemo, useCallback } from 'react';
import { useDealData } from '../store/DealDataContext';
import { DealProps } from '../types/deal';

export const useBulkDealLoader = (deals: DealProps[]) => {
  const { loadDealData } = useDealData();

  // Memoize the deal IDs to prevent unnecessary re-runs
  const dealIds = useMemo(() => {
    if (!deals || deals.length === 0) return [];
    const ids = deals.map((deal) => deal._id).filter(Boolean);
    return ids;
  }, [deals]);

  const memoizedLoadDealData = useCallback(
    (ids: string[]) => {
      loadDealData(ids);
    },
    [loadDealData]
  );

  useEffect(() => {
    if (dealIds.length > 0) {
      memoizedLoadDealData(dealIds);
    }
  }, [dealIds, memoizedLoadDealData]);
};
